import React, { useState } from 'react';
import { Typography, Box, useMediaQuery, useTheme } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { TextField as AppTextField } from '../../../../../Components/Field';
import { StepProps } from './types';
import { StepButtonBar } from './StepButtonBar';
import EvaluationStepInfo from './EvaluationStepInfo';

const Step7PlanName = ({ onNext, onBack, onCancel, currentData, evalutionStepInfo, currentStepName, onUpdateEvalution }: StepProps) => {
  const [name, setName] = useState<string>(currentData.name || '');
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const paperPadding = isMobile ? theme.spacing(3) : theme.spacing(8);

  const handleNext = () => {
    if (name.trim()) onNext({ name: name.trim() });
  };

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'flex',
          width: '100%',
          gap: '10px',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'stretch',
        }}
      >
        <div
          style={{
            width: isMobile ? '100%' : 'calc(50% - 5px)',
            flexShrink: 0,
            padding: paperPadding,
            backgroundColor: '#f7f0f1',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            justifyContent: 'center',
            alignItems: 'center',
             minHeight:"350px"
          }}
        >
          {/* <Typography
            variant="h6"
            style={{
              fontWeight: 600,
              marginBottom: theme.spacing(4),
              lineHeight: 1.4,
              textAlign: 'center',
              fontSize: isMobile ? '16px' : '18px',
            }}
          >
            {formatMessage({ id: 'law-portal.evalution.plan.name.label' })}
          </Typography> */}
          <Box style={{ maxWidth: '320px', width: '100%' }}>
            <AppTextField
              name="plan-name"
              placeholder=""
              errorTexts={[]}
              initialState={currentData.name ? { value: currentData.name } : undefined}
              onChange={(val) => setName(val?.value || '')}
            />
          </Box>
        </div>

        <EvaluationStepInfo evalutionStepInfo={evalutionStepInfo} currentStepName={currentStepName} onUpdate={onUpdateEvalution} />
      </div>

      <Box>
        <StepButtonBar
          onCancel={onCancel}
          onBack={onBack}
          onNext={handleNext}
          nextLabel="law-portal.evalution.plan.btn.save.preview"
          nextDisabled={!name.trim()}
          formatMessage={formatMessage}
        />
      </Box>
    </div>
  );
};

export default Step7PlanName;